/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyBranchInfo,
    JsonCompanyBranchInfoFromJSON,
    JsonCompanyBranchInfoFromJSONTyped,
    JsonCompanyBranchInfoToJSON,
} from './JsonCompanyBranchInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyBranchInfo
 */
export interface ApiResultOfJsonCompanyBranchInfo {
    /**
     * 
     * @type {JsonCompanyBranchInfo}
     * @memberof ApiResultOfJsonCompanyBranchInfo
     */
    data?: JsonCompanyBranchInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyBranchInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyBranchInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyBranchInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyBranchInfo
     */
    result?: ApiResultOfJsonCompanyBranchInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyBranchInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyBranchInfoFromJSON(json: any): ApiResultOfJsonCompanyBranchInfo {
    return ApiResultOfJsonCompanyBranchInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyBranchInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyBranchInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyBranchInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyBranchInfoToJSON(value?: ApiResultOfJsonCompanyBranchInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyBranchInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

